(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  class Vector1D {
    /**
     * Creates an instance of the class and initializes the value property to 0.
     */
    constructor() {
      this.value = 0;
    }

    /**
     * Initializes the vector with the given value.
     * @param {number} value - The value to initialize the vector with.
     */
    initialize(value) {
      this.value = value;
    }

    /**
     * Gets the current value of the vector.
     * @returns {number} The current value stored in the vector.
     */
    get() {
      return this.value;
    }

    /**
     * Sets the value of the vector.
     * @param {number} value - The new value to assign.
     */
    set(value) {
      this.value = value;
    }

    /**
     * Adds the specified value to the current value.
     * @param {number} value - The value to add.
     */
    add(value) {
      this.value += value;
    }

    /**
     * Subtracts the specified value from the current value.
     * @param {number} value - The value to subtract.
     */
    subtract(value) {
      this.value -= value;
    }
  }

  global.NewHomeSource.Carousel.Vector1D = Vector1D;
}(window));
